import React from 'react';
import { Typography } from '@mui/material';
import ApiKeyTable from '../tables/ApiKeyTable';

const ApiKeySection = () => {
  return (
    <>
      <Typography marginRight={1} marginTop={2} variant='h3'>
        API Keys
      </Typography>
      <Typography variant='body2' color='text.secondary' sx={{ mb: 1 }}>
        Manage API keys issued to external suppliers for the Data Exchange API.
        Keys are shown only once at creation time. Use Revoke to disable a key,
        or Rotate to replace it with a new one.
      </Typography>
      <ApiKeyTable />
    </>
  );
};

export default ApiKeySection;
